module.exports = __webpack_public_path__ + "img/fig08.5ef12ee4.jpg";